import { render } from "./AddPanelNetwork.vue?vue&type=template&id=706dc9c1&scoped=true"
import script from "./AddPanelNetwork.vue?vue&type=script&lang=js"
export * from "./AddPanelNetwork.vue?vue&type=script&lang=js"

import "./AddPanelNetwork.vue?vue&type=style&index=0&id=706dc9c1&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-706dc9c1"],['__file',"src/assets/js/components/panels/forms/AddPanelNetwork.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "706dc9c1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('706dc9c1', __exports__)) {
    api.reload('706dc9c1', __exports__)
  }
  
  module.hot.accept("./AddPanelNetwork.vue?vue&type=template&id=706dc9c1&scoped=true", () => {
    api.rerender('706dc9c1', render)
  })

}


export default __exports__